// extracted by mini-css-extract-plugin
export default {"table":"LatestClinicalReportTable_table__+rI-j"};